export default "__VITE_PUBLIC_ASSET__5953eb07__"